import React from 'react'
import "./Overview.css"
import Form from '../Form/Form'
import gmy from "../../Assets/CAtegory/gymi.jpg"
import Basketball from "../../Assets/CAtegory/basketball.jpg"
import Swimming from "../../Assets/CAtegory/swimming.jpeg"
import banhall from "../../Assets/CAtegory/hall.jpg"
import spot from "../../Assets/CAtegory/joging.webp"
import ReactOwlCarousel from 'react-owl-carousel'
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const Overview = () => {
    const responsiveOptions = {
        0: {
            items: 1,
        },
        600: {
            items: 2,
        },
        1000: {
            items: 3,
        },
    };
    return (
        <div className="overview">
            <div className="about-main">
                <div className="overview-item">
                    <div className="overview-left">
                        <div className="overview-form">
                            <Form heading={"Book Your Site Visit"} btntxt={"Book A Site Visit"} />
                        </div>
                    </div>
                    <div className="overview-right">
                        <div className="overview-title">
                            <h3>Overview</h3>
                        </div>
                        <div className="overview-detail">
                            <p>
                                Strategically located on Gurgaon’s Golf Course Road, DLF The Crest offers residents excellent connectivity to major business hubs, renowned schools, healthcare facilities, and entertainment destinations. Spread across acres of meticulously planned land, the project features six iconic towers with spacious 3, 4, and 5 BHK residences that blend contemporary interiors with timeless charm. Each home is designed to maximize natural light, ventilation, and privacy, ensuring a serene living experience amidst the vibrancy of the city.
                            </p>
                            <p>With its landscaped greens, state-of-the-art clubhouse, leisure avenues, and recreational spaces, The Crest redefines the concept of urban luxury. Whether it’s unwinding in world-class wellness facilities, enjoying serene gardens, or connecting with like-minded residents, The Crest provides a lifestyle that goes beyond just a home—it creates a complete living ecosystem for modern families.</p>
                        </div>
                        <div className="overview-category">
                            <ReactOwlCarousel
                                items={6}
                                nav={true}
                                dots={false}
                                responsive={responsiveOptions}
                            >
                                <div className="category-card">
                                    <img src={gmy} alt="Godrej Ashok Vihar Delhi" />
                                    <p>Gym</p>
                                </div>
                                <div className="category-card">
                                    <img src={Swimming} alt="Godrej Ashok Vihar" />
                                    <p>Swimming Pool</p>
                                </div>
                                <div className="category-card">
                                    <img src={banhall} alt="Godrej Ashok Vihar Delhi price" />
                                    <p>multipurpose Hall</p>
                                </div>
                                <div className="category-card">
                                    <img src={Basketball} alt="Godrej Ashok Vihar Delhi Expressway" />
                                    <p>Basketball Court</p>
                                </div>
                                <div className="category-card">
                                    <img src={spot} alt="Godrej Ashok Vihar Delhi Plans" />
                                    <p>Jogging Track</p>
                                </div>
                            </ReactOwlCarousel>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Overview
